<template>
  <div class="container">
    <Header />
    <!-- <div class="header-box">
        <iframe width="100%" frameborder="0" height="500" scrolling="no" src="http://10.126.6.239:9088/
" border=0></iframe>
    </div> -->
    <div class="banner">
      <div class="banner-text">
        <p>校长信箱</p>
        <p>President’s &nbsp; mailbox</p>
      </div>
    </div>
    <div class="content">
      <div class="messageBox">
        <div class="messageForm">
          <form class="form">
            <div class="form-item">
              <label style="text-align: right;">标题：</label>
              <el-input v-model="formInfo.title" placeholder=""></el-input>
            </div>
            <div class="form-item">
              <label style="text-align: right;visibility:hidden;">内容：</label>
              <el-input type="textarea" :rows="15" resize="none" placeholder="" v-model="formInfo.qContent">
              </el-input>
            </div>
            <div class="form-item">
              <label style="text-align: right;">手机：</label>
              <el-input class="telephone" v-model="formInfo.telephone" placeholder=""></el-input>
              <label style="text-align: right;">验证码:</label><el-input class="code phonecode" v-model="formInfo.phoneCode"
                placeholder=""></el-input>
              <el-button class="btn sendcode" :loading="loading" @click="regCode">发送验证码</el-button>
            </div>
            <div class="falseemail" v-show="telephoneID">请输入正确的手机号码！</div>
            <!------------------------------------------->
            <div class="form-item">
              <label style="text-align: right;">邮箱：</label>
              <el-input class="telephone" v-model="formInfo.email" placeholder=""></el-input>
              <span>请填写您的邮箱地址，以便回信！</span>
            </div>
            <div class="falseemail" v-show="emailID">请输入正确邮箱地址！</div>
            <!------------------------------------------->
            <div class="form-item" style="margin-bottom:0px">
              <label style="text-align: right;">验证码：</label>
              <el-input class="code" v-model="formInfo.code" placeholder=""></el-input>
              <canvas class="codeCanvas" id="s-canvasxz" @click="drawPic" width="100" height="37"></canvas>
            </div>
            <div class="falsecode" v-show="numcode">验证码不正确</div>
            <div class="form-item alone">
              <el-button class="btn" :loading="loading" @click="save">发送邮箱</el-button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer />
    <Beian />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import Beian from '@/components/beian'
export default {
  name: 'messageXzxx',
  data () {
    return {
      formInfo: {
        username: '',
        telephone: '',
        email: '',
        type: '',
        title: '',
        qContent: '',
        code: '',
        phoneCode: ''
      },
      typeList: [
        { name: '招生' },
        { name: '就业' },
        { name: '教学' },
        { name: '学生工作' },
        { name: '生活服务' },
        { name: '人才招聘' },
        { name: '出国留学' }
        // { name: '报考问题咨询' }
      ],
      identifyCodes: '1234567890',
      identifyCode: '',
      loading: false,
      messageList: [
      ],
      currentPage: 1,
      limit: 5,
      total: 0,
      type: '招生',
      emailID: false,
      telephoneID: false,
      numcode: false
    }
  },
  components: {
    Header,
    Footer,
    Beian
  },
  mounted () {
    this.drawPic()
    this.getList()
    document.title = '校长信箱'
  },
  methods: {
    getList () { // 获取留言列表
      let para = {
        page: this.currentPage,
        rows: this.limit,
        type: this.type
      }
      this.$http.getMessagesList(para).then(res => {
        console.log(res)
        this.messageList = res.list
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        console.error(err)
      })
    },
    changeType (item) { // 留言目录切换
      this.type = item.name
      this.currentPage = 1
      this.getList()
    },
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 四个数
    makeCode (l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    // 生成一个随机的颜色
    randomColor (min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic () {
      this.identifyCode = ''
      this.makeCode(4)
      let canvas = document.getElementById('s-canvasxz')
      let ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = this.randomColor(
        255,
        255
      )
      ctx.fillRect(0, 0, 100, 37)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      this.drawLine(ctx)
      this.drawDot(ctx)
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = this.randomColor(0, 200)
      ctx.font =
        this.randomNum(30, 40) + 'px SimHei'
      let x = (i + 1) * (100 / (this.identifyCode.length + 1))
      let y = this.randomNum(40, 40)
      var deg = this.randomNum(-40, 40)
      // 修改坐标原点和旋转角度
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg * Math.PI) / 180)
      ctx.translate(-x, -y)
    },
    drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.randomColor(
          100,
          255
        )
        ctx.beginPath()
        ctx.moveTo(
          this.randomNum(0, 100),
          this.randomNum(0, 37)
        )
        ctx.lineTo(
          this.randomNum(0, 100),
          this.randomNum(0, 37)
        )
        ctx.stroke()
      }
    },
    drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 40; i++) {
        ctx.fillStyle = this.randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(
          this.randomNum(0, 100),
          this.randomNum(0, 37),
          1,
          0,
          2 * Math.PI
        )
        ctx.fill()
      }
    },
    add () { // 获取更多
      let para = {
        page: this.currentPage + 1,
        rows: this.limit,
        type: this.type
      }
      this.$http.getMessagesList(para).then(res => {
        console.log(res)
        if (res.list.length > 0) {
          res.list.forEach(element => {
            this.messageList.push(element)
          })
        }
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        console.error(err)
      })
    },
    refresh () {
      setTimeout(function () {
        location.reload()
      }, 3000)
    },
    regCode () {
      if (this.formInfo.telephone === '') {
        this.$message({
          showClose: true,
          message: '请输入手机号码！',
          type: 'error',
          customClass: 'zzindex',
          offset: 80
        })
        this.loading = false
        return false
      } else {
        this.$http.sendPhoneCode({ phone: this.formInfo.telephone }).then(res => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
              customClass: 'zzindex',
              offset: 80
            })
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
              customClass: 'zzindex',
              offset: 80
            })
          }
          this.loading = false
        }).catch(err => {
          console.error(err)
          this.loading = false
          this.$message({
            showClose: true,
            message: '系统错误！',
            type: 'error',
            customClass: 'zzindex',
            offset: 80
          })
        })
      }
    },
    save () { // 留言
      this.loading = true
      this.formInfo.type = '校长信箱'
      if (this.formInfo.telephone === '' || this.formInfo.phoneCode === '' || this.formInfo.email === '' || this.formInfo.title === '' || this.formInfo.qContent === '' || this.formInfo.code === '') {
        this.$message({
          showClose: true,
          message: '请完善所有信息',
          type: 'error',
          customClass: 'zzindex',
          offset: 80
        })
        this.loading = false
        return false
      }
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (!reg.test(this.formInfo.email)) {
        this.emailID = true
        this.loading = false
        return false
      } else {
        this.emailID = false
      }

      const regx = /^1\d{10}$/
      if (!regx.test(this.formInfo.telephone)) {
        this.telephoneID = true
        this.loading = false
        return false
      } else {
        this.telephoneID = false
      }

      if (this.formInfo.code !== this.identifyCode) {
        this.numcode = true
        this.loading = false
        return false
      } else {
        this.numcode = false
      }
      this.$http.createMessage(this.formInfo).then(res => {
        if (res.success) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
            customClass: 'zzindex',
            offset: 80
          })
          this.formInfo = {
            name: '',
            telphone: '',
            type: '',
            title: '',
            content: '',
            code: '',
            phoneCode: ''
          }
          this.refresh()
        } else {
          this.$message(
            {
              showClose: true,
              message: res.msg,
              type: 'error',
              customClass: 'zzindex',
              offset: 80
            })
        }
        this.loading = false
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    }
  }
}
</script>
<style>
@media screen and (max-width: 750px) {
  .el-textarea__inner {
    background-color: transparent !important;
    border: none !important;
    font-size: 18px !important;
    color: gray;
    height: 24vh;
    margin-left: 0px;
  }
}

.el-message .el-icon-error {
  font-size: 40px;
}

.el-message {
  padding: 10px 10px 10px 15px;
}

.zzindex {
  z-index: 3000;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;

.el-button {
  border: none;
}

// --
.messageBox .el-input__inner {
  /* color: #fff; */
  color: gray;
  font-size: 25px;
  line-height: 44px !important;
  height: 44px !important;
  background-color: transparent !important;
  border: none;
  margin: 10px;
  margin-left: 0px;
}

.el-textarea__inner {
  background-color: transparent !important;
  border: none !important;
  font-size: 25px !important;
}

.messageBox .el-select input::-webkit-input-placeholder {
  color: #fff;
}

.messageBox .el-select .el-input__inner {
  padding-left: 0;
}

.messageForm .el-icon-arrow-up:before {
  content: "\e6de" !important;
  font-size: 36px;
  line-height: 42px;
  color: #e40a83;
}

// --
.banner {
  height: 570px;
  // height: 875px;
  overflow: hidden;
  background: url('../assets/banner.jpg');
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
  max-height: 570px !important;
  position: relative;

  // margin-top: 58.5px;
  .banner-text {
    // border: 1px solid ;
    position: absolute;
    // top: 53.85% !important;
    top: 48% !important;
    left: 50%;
    transform: translate(-50%, -50%);

    p {
      &:nth-of-type(1) {
        font-size: 1.3rem;
        /* font-weight: bold; */
        color: #ffffff;
        line-height: 0px;
        text-shadow: 0px 10px 21px rgba(37, 37, 37, 0.65);
      }

      &:nth-of-type(2) {
        font-size: 0.43rem;
        color: white;
        line-height: 0;
        margin-top: -10px;
        font-weight: bold;
      }
    }
  }
}

.content {
  font-family: “Noto Sans SC”;
  font-weight: 400;

  .messageBox {
    background: #4e0072;
    color: #fff;
    // height: 918px;
    padding-top: 122px;
    display: flex;
    // justify-content: center;
    padding-bottom: 200px;

    .messageTypeList {
      margin-left: 212px;
      margin-top: -5px;

      p {
        font-size: 41px;
        font-weight: bold;
        margin: 0 0 83px;
      }

      ul {
        list-style: none;
        margin-left: 92px;
        padding: 0;
        margin-top: 0;

        li {
          font-size: 25px;
          width: 106px;
          height: 43px;
          line-height: 43px;
          border-radius: 10px;
          padding-left: 3px;
          margin-bottom: 3px;
          cursor: pointer;

          &.active {
            background: #e4007f;
          }
        }
      }
    }

    .messageForm {
      background: #f6f2e8;
      // width: 961px;
      width: 73%;
      color: #717171;
      // margin-left: 224px;
      margin: 0 auto;
      height: 945px;
      padding: 98px 0 0 108px;

      .alone {
        padding-top: 60px;
      }

      .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 35px;
        letter-spacing: 3px;

        &.type {
          margin-bottom: 42px;
        }

        label {
          width: 112px;
          font-size: 25px;
        }

        .el-select {
          background: #e2e0dd;
          width: 223px;
          height: 37px;
          line-height: 37px;
          border-radius: 10px;
          color: #fff !important;
          padding-right: 17px;
          padding-left: 44px;

          input {
            font-size: 25px;
            padding-left: 0;
            line-height: 37px;
          }
        }

        .el-input {
          background: #e2e0dd;
          border-radius: 10px;
          // width: 768px;
          width: 80%;
          height: 50px;
        }

        .telephone {
          // width: 284px;
          width: 45%;
          height: 50px;
        }

        span {
          font-size: 16.4px;
          margin-left: 30px;
          letter-spacing: 1px;
        }

        .code {
          width: 120px;
          margin-right: 30px;
          margin-top: 0;
        }

        .code.phonecode.el-input {
          width: 105px;
          margin-right: 0;
        }

        button.sendcode {
          font-size: 15px;
          width: 90px;
          margin-left: 5px;
        }

        .el-textarea {
          background-color: #e2e0dd;
          border-radius: 10px;
          // width: 768px;
          width: 80%;
          // height: 179px;
        }

        .btn {
          background: #e4007f;
          color: #fff;
          // margin: 0 auto;
          margin-left: 365px;
          width: 180px;
          height: 55px;
          line-height: 44px;
          padding: 0;
          font-size: 18px;
          border-radius: 10px;
          margin: 0 auto;
        }
      }

      .falseemail {
        color: red;
        margin-left: 113px;
        margin-top: -20px;
        margin-bottom: 12px;
        font-size: 16px;
      }

      .falsecode {
        color: red;
        margin-left: 113px;
        margin-top: 10px;
        margin-bottom: -10px;
        font-size: 16px;
      }
    }
  }

  .mesageHistroy {
    .histroyTitle {
      height: 173px;
      background: #7e45b8;
      color: #fff;
      font-size: 62.5px;
      font-weight: bold;
      text-shadow: 10px 10px 21px rgba(37, 37, 37, 0.65);
      padding-top: 73px;
      padding-left: 802px;
    }

    .histroyList {
      // height: 1560px;
      background: #f6f2e8;
      color: #717171;
      font-size: 20.85px;

      .histroy-item {
        width: 1399px;
        margin: 0 0 0 305px;

        .item {
          padding-left: 203px;
          padding-right: 279px;
          margin: 0 auto;
          padding-top: 56px;

          .top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 23px;
          }

          .item-content {
            min-height: 69px;
            margin-bottom: 29px;
            line-height: 50px;
          }

          .reply {
            margin-bottom: 55px;
            line-height: 50px;

            span {
              color: #e4007f;
            }
          }
        }

        .el-divider--horizontal {
          margin: 0;
          height: 3px;
          background: #dcdcdc;
        }
      }
    }

    .addMore {
      // text-align: center;
      padding: 43px 0 75px 893px;
      opacity: 0.5;

      div {
        display: inline-block;
        cursor: pointer;
        text-align: center;
      }

      span {
        color: #e4007f;
        font-size: 35px;
      }

      p {
        margin: 15px 0 0;
        color: #e85555;
        font-size: 25px;
      }
    }
  }
}

.hover {
  top: unset;
  width: unset;
}

@media screen and (max-width: 1730px) {
  .container {
    .content {
      .messageForm {
        margin: 0 auto;
      }

      .mesageHistroy {
        .histroyTitle {
          padding-left: 746px;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 249px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1667px) {
  .container {
    .content {
      .messageForm {
        margin: 0 auto;

        .form-item {
          .el-input {
            width: 688px;
          }

          .telephone {
            width: 284px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 688px;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          padding-left: 696px;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 189px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1610px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 140px;
      }

      .messageForm {
        margin: 0 auto;
      }

      .mesageHistroy {
        .histroyTitle {
          padding-left: 696px;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 119px;
          }
        }

        .addMore {
          // text-align: center;
          padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1535px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 40px;
      }

      .messageForm {
        margin: 0 auto;
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            margin: 0 0 0 20px;
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1435px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 30px;
      }

      .messageForm {
        margin: 0 auto;
        width: 860px;
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 1099px;
            margin: 0 auto;
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1225px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 30px;
      }

      .messageForm {
        margin: 0 auto;
        width: 700px;

        .form-item {
          .el-input {
            width: 558px;
          }

          .telephone {
            width: 234px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 558px;
          }

          .btn {
            margin-left: 0;
            margin: 10px auto;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 1099px;
            margin: 0 auto;
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1120px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 30px;
      }

      .messageForm {
        margin: 0 auto;
        width: 700px;

        .form-item {
          .el-input {
            width: 558px;
          }

          .telephone {
            width: 234px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 558px;
          }

          .btn {
            margin-left: 0;
            margin: 10px auto;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 900px;
            margin: 0 auto;

            .item {
              padding-left: 150px;
              padding-right: 150px;
            }
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media screen and (max-width: 1060px) {
  .container {
    .content {
      .messageTypeList {
        margin-left: 30px;
      }

      .messageForm {
        margin: 0 auto;
        width: 650px;
        padding: 98px 0 0 58px;

        .form-item {
          .el-input {
            width: 450px;
          }

          .telephone {
            width: 180px;
          }

          .code {
            width: 120px;
            margin-right: 30px;
          }

          .el-textarea {
            width: 450px;
          }

          .btn {
            width: 125px;
            height: 44px;
            margin-left: 0;
            margin: 10px auto;
          }
        }
      }

      .mesageHistroy {
        .histroyTitle {
          text-align: center;
          padding-left: 0;
        }

        .histroyList {
          .histroy-item {
            width: 900px;
            margin: 0 auto;

            .item {
              padding-left: 150px;
              padding-right: 150px;
            }
          }
        }

        .addMore {
          text-align: center;
          padding: 43px 0 75px;
          // padding: 43px 0 75px 823px;
        }
      }
    }
  }
}

@media (min-width: 1025px) and (max-width:1366px) {
  .banner .banner-text {
    top: 53.85% !important;
  }

  .content .messageBox .messageForm .form-item .btn {
    width: 125px;
    height: 44px;
  }

  .content .messageBox .messageForm .alone {
    padding-top: 20px;
  }

  .content .messageBox .messageForm {
    height: auto;
  }

  .banner .banner-text p:nth-of-type(2) {
    margin-top: 1.1rem;
    margin-left: -20px;
  }

  .content .messageBox .messageForm .form-item label {
    font-size: 20px;
  }

  .banner {
    width: 100%;
    height: 570px;
    overflow: hidden;
    // background: url('../assets/banner.png');
    background-position: left;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    // color: #fff;
    justify-content: center;

    h1 {
      margin: 0 auto;
      font-size: 93px;
      // font-weight: bold;
    }

    p {
      font-size: 37px;
      // font-weight: bold;
      width: 100%;
      text-align: center;
      margin: 0 auto;

      &:nth-of-type(2) {
        margin-top: 10px;
      }
    }
  }

  .content {
    .messageBox-master {
      background: #4e0072;
      color: #fff;
      padding-top: 75px;
      padding-bottom: 80px;

      .btn {
        background: #e4007f;
        color: #fff;
        margin: 62px auto 0;
        display: block;
        width: 180px;
        height: 76px;
        line-height: 76px;
        padding: 0;
        font-size: 25px;
        border-radius: 10px;
        border: none;
      }

      .messageForm {
        background: #f6f2e8;
        width: 100%;
        color: #717171;
        margin: 0 auto;
        height: auto;
        box-sizing: border-box;
        padding: 95px 0 0 105px;

        .form-item {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          line-height: 57px;
          margin-bottom: 38px;

          &.type {
            margin-bottom: 45px;
          }

          label {
            width: 131px;
            font-size: 25px;
          }

          .el-input {
            background: #e2e0dd;
            border-radius: 10px;
            width: 70%;
            color: #717171;
          }

          .telephone {
            width: 622px;
          }

          span {
            font-size: 25px;
            margin-left: 35px;
            color: #717171;
            margin-left: 130px;
          }

          .code {
            width: 181px;
            margin-right: 30px;
            margin-top: 0px;
          }

          .el-textarea {
            background-color: #e2e0dd;
            border-radius: 10px;
            // width: 1104px;
            width: 70%;
            height: 50%;
            margin-bottom: 8px;
            color: #717171;
          }
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .content .messageBox .messageForm .form-item label {
    font-size: 20px;
  }

  .content .messageBox .messageForm {
    height: auto;
  }

  .content .messageBox .messageForm .alone {
    padding-top: 20px;
  }

  .banner {
    width: 100%;
    height: 570px;
    overflow: hidden;
    // background: url('../assets/banner.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    // color: #fff;
    justify-content: center;

    .banner-text {
      // border: 1px solid ;
      position: absolute;
      top: 46%;
      left: 50%;
      transform: translate(-50%, -11%);
      width: auto;
      text-align: left;

      p {
        &:nth-of-type(1) {
          // font-size: 69.333px;
          font-size: 1.3rem;
          // font-weight: bold;
          color: #ffffff;
          line-height: 0px;
          text-shadow: 0px 10px 21px #252525;
          font-weight: unset;
        }

        &:nth-of-type(2) {
          font-weight: bold;
          // font-size: 23px;
          font-size: .43rem;
          color: white;
          line-height: 0;
          margin-top: 1.1rem;
          // margin-left: 8vw;
        }
      }
    }

    h1 {
      margin: 0 auto;
      font-size: 93px;
      // font-weight: bold;
    }

    p {
      font-size: 37px;
      // font-weight: bold;
      width: 100%;
      // text-align: center;
      margin: 0 auto;
    }
  }

  .content {
    .messageBox-master {
      background: #4e0072;
      color: #fff;
      padding-top: 75px;
      padding-bottom: 80px;

      .btn {
        background: #e4007f;
        color: #fff;
        margin: 62px auto 0;
        display: block;
        width: 208px;
        height: 76px;
        line-height: 76px;
        padding: 0;
        font-size: 25px;
        border-radius: 10px;
        border: none;
      }

      .messageForm {
        background: #f6f2e8;
        width: 100%;
        color: #717171;
        margin: 0 auto;
        height: auto;
        box-sizing: border-box;
        padding: 95px 0 0 105px;

        .form-item {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          line-height: 57px;
          margin-bottom: 38px;

          &.type {
            margin-bottom: 45px;
          }

          label {
            width: 131px;
            font-size: 25px;
          }

          .el-input {
            background: #e2e0dd;
            border-radius: 10px;
            width: 70%;
            color: #717171;
          }

          .telephone {
            width: 70%;
          }

          span {
            font-size: 25px;
            margin-left: 35px;
            color: #717171;
            margin-left: 130px;
          }

          .code {
            width: 181px;
            margin-right: 30px;
            margin-top: 0px;
          }

          .el-textarea {
            background-color: #e2e0dd;
            border-radius: 10px;
            // width: 1104px;
            width: 70%;
            height: 50%;
            margin-bottom: 8px;
            color: #717171;
          }
        }
      }
    }
  }
}

@media screen and (max-width:340px) {
  .container {
    margin: 0 auto;
    width: 106vw;
    overflow: hidden;

    .banner {
      width: 100%;
      height: 185px;
      // min-height: 21vh;
      background-position: center;
      // background-size: 100%;
      margin-top: -40px;

      .banner-text {
        width: 100%;

        p {
          &:nth-of-type(1) {
            font-size: 21px;
            font-weight: bold;
            text-align: center;
          }

          &:nth-of-type(2) {
            font-size: 14px;
            margin-top: 10px;
            margin-left: 126px;
          }
        }
      }
    }
  }

  .content {
    .messageBox {
      width: 100%;
      padding-top: 5vh;
      margin-bottom: -27vh;

      .messageForm {
        padding: 5vw;
        padding-left: 0;
        box-sizing: border-box;
        width: 100%;
        height: auto;

        .form {
          .alone {
            margin-top: -60px;
          }

          .form-item {
            flex-wrap: wrap;

            label {
              width: 30vw;
              font-size: 18px;
            }

            .el-input {
              width: 66%;
            }

            .el-textarea {
              width: 66%;
            }

            span {
              width: 50%;
              text-align: left;
              margin-left: 30vw;
            }

            .code {
              width: 32%;
              margin-right: 4vw;
            }

            .el-button {
              margin: -10vh auto;
            }

            .btn {
              // width: 50vw;
              height: 7vh;
              line-height: 7vh;
            }
          }
        }
      }
    }
  }
}

@media (min-width:340px) and (max-width:750px) {
  .content .messageBox .messageForm .falseemail {
    margin-top: 0;
  }

  .el-textarea__inner {
    font-size: 18px !important;
  }

  .container {
    margin: 0 auto;
    width: 100vw;
    overflow: hidden;

    .banner {
      width: 100vw;
      height: auto;
      min-height: 21vh;
      background-position: center;
      background-size: cover;
      margin-top: -40px;

      .banner-text {
        // border: 1px solid ;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        text-align: center;

        p {

          // margin-left: 34%;
          &:nth-of-type(1) {
            font-size: 21px;
            font-weight: bold;
            color: #ffffff;
            line-height: 0px;
            // text-align: center;
            // text-shadow: 0px 10px 21px rgb(37 37 37 / 65%);
          }

          &:nth-of-type(2) {
            font-weight: bold;
            font-size: 14px;
            color: white;
            line-height: 0;
            margin-top: 0px;
            margin-left: 72px;
          }
        }
      }
    }
  }

  .content {
    .messageBox {
      width: 100%;
      padding-top: 5vh;
      margin-bottom: -27vh;

      .el-input__inner {
        border: 1px solid black;
      }

      .messageForm {
        padding: 5vw;
        padding-left: 0;
        box-sizing: border-box;
        width: 100%;
        height: auto;

        .form {
          .alone {
            margin-top: -40px;
          }

          .form-item {
            flex-wrap: wrap;
            margin-bottom: 10px;

            label {
              width: 30vw;
              font-size: 18px;
            }

            .el-input {
              width: 66%;
              height: 30px;
              margin-top: 3px;
            }

            .el-textarea {
              width: 66%;
            }

            span {
              width: 65%;
              text-align: left;
              margin-left: 30vw;
              font-size: 14px;
            }

            .code {
              width: 32%;
              margin-right: 4vw;
            }

            .el-button {
              margin: 2vh auto;
            }

            .btn {
              width: auto;
              padding: 8px;
              height: auto;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}

.header-box {
  width: 100%;
  position: fixed;
  height: auto;
  left: 0;
  top: 0;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/views/messageXzxx.vue